import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactSearch } from 'src/app/shared/models/contact-search.model';
import { Contact } from 'src/app/shared/models/contact.models';

@Injectable({
  providedIn: 'root'
})
export class ContactApiService {

  constructor(private http: HttpClient) { }

  searchContacts(contactSearch: ContactSearch): Observable<Contact[]> {
    return this.http.post<Contact[]>('/api/Contacts/Search', contactSearch);
  }
}
